export default "__VITE_ASSET__WBwGQfVh__"